import { jsxs, jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { textStyles } from "./textStyles.js";
import { token } from "./token.js";
import { useGroupParent } from "./useGroupContext.js";
function HelperText({
  icon,
  isInvalid,
  children,
  ...props
}) {
  useGroupParent("HelperText");
  return /* @__PURE__ */ jsxs(HelperTextStyled, {
    $isInvalid: isInvalid,
    $hasIcon: Boolean(icon),
    ...props,
    children: [icon && /* @__PURE__ */ jsx(Icon, {
      children: icon
    }), children]
  });
}
const HelperTextStyled = styled.div.withConfig({
  displayName: "HelperTextStyled",
  componentId: "sc-1gcvrkz-0"
})(["", " display:flex;align-items:center;margin-top:", ";padding-top:", ";color:", ";"], textStyles.uiTextS, token.spacing2, (props) => props.$hasIcon ? "2px" : "0", (props) => props.$isInvalid ? token.red500 : token.colorTextMuted);
const Icon = styled.div.withConfig({
  displayName: "Icon",
  componentId: "sc-1gcvrkz-1"
})(["flex:none;align-self:flex-start;margin-top:-2px;margin-right:", ";"], token.spacing2);
export {
  HelperText
};
//# sourceMappingURL=HelperText.js.map
